function getDailyIndex(length: number): number {
  const baseDate = new Date(2026, 3, 30); // mês começa em 0
  const today = new Date();

  baseDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffInMs = today.getTime() - baseDate.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return ((diffInDays % length) + length) % length;
}

export function getModelsByPage(page: string): string[] {
  const models: Record<string, string[]> = {
    shadowzone: [
      new URL("./assets/models/shadow/shadow_a.glb", import.meta.url).href,
      new URL("./assets/models/shadow/shadow_b.glb", import.meta.url).href,
      new URL("./assets/models/shadow/shadow_c.glb", import.meta.url).href,
      new URL("./assets/models/shadow/shadow_d.glb", import.meta.url).href,
    ],
    neozone: [
      new URL("./assets/models/neo/neo_a.glb", import.meta.url).href,
      new URL("./assets/models/neo/neo_b.glb", import.meta.url).href,
      new URL("./assets/models/neo/neo_c.glb", import.meta.url).href,
      new URL("./assets/models/neo/neo_d.glb", import.meta.url).href,
    ],
    openzone: [
      new URL("./assets/models/open/open_a.glb", import.meta.url).href,
      new URL("./assets/models/open/open_b.glb", import.meta.url).href,
      new URL("./assets/models/open/open_c.glb", import.meta.url).href,
      new URL("./assets/models/open/open_d.glb", import.meta.url).href,

    ],
    herozone: [
      new URL("./assets/models/hero/hero_a.glb", import.meta.url).href,
      new URL("./assets/models/hero/hero_b.glb", import.meta.url).href,
      new URL("./assets/models/hero/hero_c.glb", import.meta.url).href,
      new URL("./assets/models/hero/hero_d.glb", import.meta.url).href,

    ],
  };

  return models[page] || [];
}

export function getDailyModelByPage(page: string): string {
  const models = getModelsByPage(page);
  if (!models.length) return "";

  return models[getDailyIndex(models.length)];
}